import type { SchemaOf } from '../../helpers';
import { Joi, makeAllOptional } from '../../helpers';

export interface IConfig {
  volume: number;
  pitch: number;
  rate: number;
  ffmpegBoostVolume: string;
  synthesizeTimeout: number;
  announcementSynthesizeTimeout: number;
  textDisplaySynthesizeTimeout: number;
  textDisplayDelay: number;
  textDisplayTimeMin: number;
  textDisplayTimeMax: number;
  textDisplayTimePerCharacter: number;
}

export const schemaMapDefault: SchemaOf<IConfig> = {
  rate: Joi.number().required(),
  pitch: Joi.number().required(),
  volume: Joi.number().required(),
  ffmpegBoostVolume: Joi.string().required(),
  synthesizeTimeout: Joi.number().required(),
  announcementSynthesizeTimeout: Joi.number().required(),
  textDisplaySynthesizeTimeout: Joi.number().required(),
  textDisplayDelay: Joi.number().required(),
  textDisplayTimeMin: Joi.number().required(),
  textDisplayTimeMax: Joi.number().required(),
  textDisplayTimePerCharacter: Joi.number().required(),
};

export const schemaMap = makeAllOptional(schemaMapDefault);

export const defaultConfig: IConfig = {
  volume: 1,
  rate: 0.9,
  pitch: 1,
  ffmpegBoostVolume: '4.0',
  synthesizeTimeout: 5000,
  announcementSynthesizeTimeout: 10000,
  textDisplaySynthesizeTimeout: 2500,
  textDisplayDelay: 400,
  textDisplayTimeMin: 1000,
  textDisplayTimeMax: 5000,
  textDisplayTimePerCharacter: 65,
};
